<template>
  <el-dialog class="dialog-1"
    :visible.sync="dialogVisible"
    top="8vh"
    width="95vw"
    :close-on-click-modal="false" :show-close="true" @close="onClose">
    <template #title>
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </template>
    <div class="dialog-1-main">
      <MeterMapEditor v-if="dialogVisible&&isEditor==='MeterMapEditor'" />
    </div>
  </el-dialog>
</template>

<script>
import MeterViewDiagram from "./MeterViewDiagram";
import MeterMapEditor from "./MeterMapEditor";
export default {
  name: "MeterMapNodeEditor",
  provide(){
    return{
      setCard:this.setCardIndex
    }
  },
  inject:['mainObj','componentId','setComponentId',],
  components: {MeterMapEditor, MeterViewDiagram},
  data(){
    return{
      dialogVisible:false,
      meter_id:null,
      excel_list2:[],
      isEditor:'MeterMapEditor',
    }
  },
  methods:{
    show(meter_id,callback){
      const that=this;
      that.mainObj.map_id=meter_id;
      that.dialogVisible=true;
    },
    onClose(){

    },
    setCardIndex(cardIndex){
      this.isEditor=cardIndex;
    }
  },
}
</script>

<style lang="scss" scoped>
.dialog-1{
  >>>.el-dialog__body{
    padding: 0;

    .dialog-1-main{
      position: relative;
    }
  }
  //>>>.el-dialog__header{
  //  padding: 0;
  //}
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterMapNodeEditor.vue